// extracted by mini-css-extract-plugin
module.exports = {"welcome":"index_welcome__1K2sr","welcomeText":"index_welcomeText__1xaSY","welcomeSubText":"index_welcomeSubText__DCDgb","welcomeImage":"index_welcomeImage___UO8H"};